export default {"src":"/_next/static/media/delete.1e420c23.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};